<script setup lang="ts">
import { ThumbsDown, ThumbsUp } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { Field, FieldGroup, FieldLabel, FieldSet } from '@/components/ui/field';
import {
    Popover,
    PopoverAnchor,
    PopoverContent,
} from '@/components/ui/popover';
import { Textarea } from '@/components/ui/textarea';
import useFeedback from '@/composables/useFeedback.ts';
import type { File } from '@/types/api';

const props = defineProps<{
    file: File;
}>();

const { vote, response, recordVote, showFeedbackPopover, recordResponse } =
    useFeedback(props.file.uid, props.file.vote);
</script>

<template>
    <Popover
        v-model:open="showFeedbackPopover"
        v-slot="{ close }"
    >
        <PopoverAnchor as-child>
            <ButtonGroup>
                <Button
                    variant="outline"
                    @click="() => recordVote(1)"
                    :disabled="vote === 1"
                    class="disabled:opacity-100"
                >
                    <ThumbsUp
                        :class="{
                            'fill-foreground [&_path:last-child]:stroke-background':
                                vote === 1,
                        }"
                    />
                </Button>
                <Button
                    variant="outline"
                    @click="() => recordVote(-1)"
                    :disabled="vote === -1"
                    class="disabled:opacity-100"
                >
                    <ThumbsDown
                        :class="{
                            'fill-foreground [&_path:last-child]:stroke-background':
                                vote === -1,
                        }"
                    />
                </Button>
            </ButtonGroup>
        </PopoverAnchor>
        <PopoverContent
            class="p-small min-w-sm"
            align="end"
        >
            <form @submit.prevent="recordResponse">
                <FieldGroup>
                    <FieldSet>
                        <FieldGroup>
                            <Field>
                                <FieldLabel for="feedback">
                                    Danke für Ihre Rückmeldung!
                                </FieldLabel>
                                <Textarea
                                    id="feedback"
                                    v-model="response"
                                    :placeholder="`Teilen Sie uns mit, warum dieses Dokument ${vote === 1 ? 'hilfreich' : 'nicht hilfreich'} war. Ihr Feedback hilft uns, besser zu werden.`"
                                    :rows="4"
                                />
                            </Field>
                        </FieldGroup>
                    </FieldSet>
                    <Field orientation="horizontal">
                        <Button type="submit"> Absenden </Button>
                        <Button
                            variant="outline"
                            type="button"
                            @click="close"
                        >
                            Schließen
                        </Button>
                    </Field>
                </FieldGroup>
            </form>
        </PopoverContent>
    </Popover>
</template>
